<template>
    <v-content pa-0 style="min-height: 100vh;">
        <Header></Header>
        <div
                style="position: relative;display: flex;justify-content: center;align-items: center"
                :style="$vuetify.breakpoint.mdAndUp ? {'padding-top': '88px'}:{}"
        >
            <img
                    style="width: 100%"
                    v-if="$vuetify.breakpoint.smAndDown"
                    :src="require('../assets/bg-cover/mobile-comingsoon.png')"
            />
            <img style="width: 100%" v-else :src="require('../assets/bg-cover/desktop-comingsoon.png')" />
        </div>
        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import Service from "../services"

    export default {
        name: "ComingSoon",
        components: {
            Header,
            Footer
        },
        created () {
            Service.analytics.sendPageView({
                path: this.$route.path
            })
        }
    }
</script>

<style scoped>

</style>